<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        launchOptions: [], // 借支入口
        stateOptions: [], // 核销状态
        loanSubjectOptions: [], // 核销类别
        form: [
          { // 借支流水号
            label: '借支流水号',
            value: 'oaLoanId',
            type: 'input',
            placeholder: '请输入借支流水号',
          },
          { // 借支入口
            label: '借支入口',
            value: 'launch',
            type: 'select',
            placeholder: '请选择借支入口',
            default: -1,
          },
          { // 申请人
            label: '申请人',
            value: 'userName',
            type: 'input',
            placeholder: '请输入申请人',
          },
          { // 借支时间
            label: '借支时间',
            value: 'Time',
            type: 'date',
            default: [],
            placeholder: '请选择借支时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 核销状态
            label: '核销状态',
            value: 'state',
            type: 'select',
            default: -1,
            placeholder: '请选择核销状态',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 订单号码
            label: '订单号码',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号码',
          },
          { // 申请手机
            label: '申请手机',
            value: 'mobilePhone',
            type: 'input',
            placeholder: '请输入申请手机',
          },
          { // 核销类别
            label: '核销类别',
            value: 'loanSubject',
            type: 'select',
            default: -1,
            placeholder: '请选择核销类别',
          },
          { // 支付流水号
            label: '支付流水号',
            value: 'payIdStr',
            type: 'input',
            placeholder: '请输入支付流水号',
          },
          { // 借支金额
            label: '借支金额',
            value: 'amount',
            type: 'inputrange',
            placeholder: '请输入借支金额',
          },
          { // 未核销金额
            label: '未核销金额',
            value: 'noPayed',
            type: 'inputrange',
            placeholder: '请输入未核销金额',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 借支时间
      if (searchBoxData.Time[0]) {
        searchBoxData.startTime = this.formatDate(searchBoxData.Time[0]);
        searchBoxData.endTime = this.formatDate(searchBoxData.Time[1]);
      }
      delete searchBoxData.Time;
      if (searchBoxData.amount[0]) {
        searchBoxData.amountStar = searchBoxData.amount[0];
        searchBoxData.amountEnd = searchBoxData.amount[1];
      }
      delete searchBoxData.amount;
      if (searchBoxData.noPayed[0]) {
        searchBoxData.noPayedStar = searchBoxData.noPayed[0];
        searchBoxData.noPayedEnd = searchBoxData.noPayed[1];
      }
      delete searchBoxData.noPayed;
      this.$refs.tableBox.saveSearchBoxData({
        borrowType: -1,
        loanType: -1,
        threeOrgId: -1,
        twoOrgId: -1,
        ...searchBoxData,
      });
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'LOAN_STATE,LOAN_SUBJECT,BORROW_ENTRANCE',
    });
    this.searchBoxData.stateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
    this.searchBoxData.loanSubjectOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[1],
    ];
    this.searchBoxData.launchOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[2],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
